import { render, staticRenderFns } from "./ReturnReason.vue?vue&type=template&id=748e29c2&scoped=true&"
import script from "./ReturnReason.vue?vue&type=script&lang=js&"
export * from "./ReturnReason.vue?vue&type=script&lang=js&"
import style0 from "./ReturnReason.vue?vue&type=style&index=0&id=748e29c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748e29c2",
  null
  
)

export default component.exports